import React from 'react'
import { Box, BoxProps } from 'components/Box'

export const GridCard: React.FC<BoxProps & { noBorder?: boolean }> = ({ children, noBorder=false, ...props }) => {
  return <Box {...props} className="OrdoCardGrid-card OrdoGridCard-root" sx={[
    (theme) => ({
      display: 'flex',
      flexDirection: 'column',
      width: '50%',
      minWidth: '50%',
      height: 'auto',
      aspectRatio: '1/1',
      padding: theme.spacing(0.5),
      [theme.breakpoints.up('sm')]: {
        width: '50%',
        minWidth: '50%',
        padding: theme.spacing(1),
      },
      [theme.breakpoints.up('md')]: {
        width: '33%',
        minWidth: '33%',
      },
      [theme.breakpoints.up('lg')]: {
        width: '25%',
        minWidth: '25%',
      },
      [theme.breakpoints.up('xl')]: {
        width: '20%',
        minWidth: '20%',
      },
      [theme.breakpoints.up('xxl')]: {
        width: '16.66%',
        minWidth: '16.66%',
        padding: theme.spacing(2),
      },
      '@media print': {
        aspectRatio: 'auto',
        breakInside: 'avoid',
      },
    }),
    ...(Array.isArray(props.sx) ? props.sx : [props.sx])
  ]}>
    <Box className="OrdoGridCard-content" sx={(theme) => ({
      flexGrow: 1,
      ...(!noBorder && {
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: theme.palette.divider,
        borderRadius: '10px',
      }),
    })}>
      { children }
    </Box>
  </Box>
}

export default GridCard
